<template>
	<div class="page">
		<div class="tabLine">
			<!-- <div class="tabItem" :class="[curTab==0?'active':'']" @click="changeTab(0)">全部订单</div> -->
			<div class="tabItem" :class="[curTab==1?'active':'']" @click="changeTab(1)">消费订单</div>
			<!-- <div class="tabItem" :class="[curTab==2?'active':'']" @click="changeTab(2)">医疗订单</div> -->
			<div class="tabItem" :class="[curTab==3?'active':'']" @click="changeTab(3)">充值订单</div>
			<div class="tabItem" :class="[curTab==4?'active':'']" @click="changeTab(4)">退换货订单</div>
			<!-- <div class="tabItem" :class="[curTab==5?'active':'']" @click="changeTab(5)">线上订单</div> -->
		</div>
		<div v-show="curTab===1">
			<saleOrder></saleOrder>
		</div>
		<!-- <div v-show="curTab===2">
			<saleOrder :orderType="'医疗'"></saleOrder>
		</div> -->
		<div v-show="curTab===3">
			<rechargeOrder></rechargeOrder>
		</div>
		<div v-show="curTab===4">
			<returnOrder></returnOrder>
		</div>
		<div v-show="curTab===5">
			<onlineOrder></onlineOrder>
		</div>
	</div>
</template>
<script>
	import saleOrder from "./saleOrder/list.vue"
	import rechargeOrder from "./rechargeOrder/list.vue"
	import returnOrder from "./returnOrder/list.vue"
	import onlineOrder from "./onlineOrder/list.vue"
	export default {
		components:{saleOrder,rechargeOrder,returnOrder,onlineOrder},
		data(){
			return{
				curTab:1,
				
			}
		},
		computed:{
			
		},
		beforeRouteEnter(to,from,next){
			next()
			// next(vm=>{
			// 	if(vm.page.page===1){
			// 		vm.getTableData();
			// 	}
			// })
			// if(from.path==='/yiliao/ymqcAdd'){
			// 	next(vm=>{
			// 		vm.page.page=1;
			// 		vm.getTableData();
			// 	})
			// }else{
			// 	next()
			// }
		},
		mounted(){
			
		},
		methods: {
			changeTab(i){
				this.curTab=i;
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.tabLine{
		margin-top:20px;
		display: flex;
		.tabItem{
			padding:0 16px;
			line-height: 32px;
			border-radius: 2px;
			text-align: center;
			margin-left:20px;
			margin-bottom:20px;
			border:1px solid rgba(0,0,0,.15);
			cursor: pointer;
			&.active{
				background-color: #1890FF;
				color:#fff;
				border-color:#1890FF;
			}
		}
	}
	.searchBox{
		.el-form-item{
			margin-bottom:0;
		}
	}
	.pageConBox{
		padding:0 20px;
		min-height: 600px;
	}
}
</style>
